module.exports = __webpack_public_path__ + "img/chalk_2.ae7d1b5f.png";